import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { editMilestoneError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return ({ milestone, nextMilestone }) =>
    present(
      repository
        .editMilestone(milestone, nextMilestone)
        .then(({ impactedElements, ...milestone }) => ({
          impactedElements,
          milestone,
        }))
        .catch((error) =>
          Promise.reject({
            error: { ...editMilestoneError, ...error },
            nextMilestone,
            milestone,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
